import * as actions from "./overview.actions";
import { CreateEmailSchedulerRuleForm } from "validation/components/EmailScheduler/emailSchedulerFormRules";
import { ActionType, createReducer } from "typesafe-actions";
import { deleteSchedulerRule, fetchSchedulerOverviewConfigs } from "./overview.actions";
import { finishFormSubmit, resetApiError } from "store/features/general";

export type EmailSchedulerOverviewState = Readonly<{
    isFetching: boolean;
    isDeleting: boolean;
    hasError: boolean;
    configurations: CreateEmailSchedulerRuleForm[];
}>;

type EmailSchedulerOverviewAction = ActionType<typeof actions>;

export const emailSchedulerOverviewInitialState: EmailSchedulerOverviewState = {
    isFetching: false,
    isDeleting: false,
    hasError: false,
    configurations: [],
};

export const emailSchedulerOverviewReducer = createReducer<EmailSchedulerOverviewState, EmailSchedulerOverviewAction>(
    emailSchedulerOverviewInitialState
)
    .handleAction(fetchSchedulerOverviewConfigs.request, () => {
        return {
            ...emailSchedulerOverviewInitialState,
            isFetching: true,
        };
    })
    .handleAction(fetchSchedulerOverviewConfigs.success, (state, { payload: { emailConfigurations } }) => {
        return {
            ...state,
            isFetching: false,
            configurations: emailConfigurations,
        };
    })
    .handleAction([fetchSchedulerOverviewConfigs.failure, deleteSchedulerRule.failure], (state) => {
        return {
            ...state,
            isFetching: false,
            isDeleting: false,
            hasError: true,
        };
    })
    .handleAction(deleteSchedulerRule.request, (state) => {
        return {
            ...state,
            isDeleting: true,
        };
    })
    .handleAction(deleteSchedulerRule.success as never, (state) => {
        return {
            ...state,
            isDeleting: false,
        };
    })
    .handleAction(resetApiError as never, (state) => {
        return {
            ...state,
            hasError: false,
        };
    })
    .handleAction(finishFormSubmit as never, () => {
        return emailSchedulerOverviewInitialState;
    });
